var SaleTaxModule = (function () {
    function SaleTaxModule() {
    }
    return SaleTaxModule;
}());
export { SaleTaxModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/saletax.module.ts.pre-build-optimizer.js